if (!customElements.get('collapsible-tabs')) {
  customElements.define(
    'collapsible-tabs',
    class CollapsibleTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.detailsElements = this.querySelectorAll('.accordion-details');
        this.colorScheme = this.dataset.colorScheme;

        this.detailsElements.length > 0 &&
          this.detailsElements.forEach((details) => {
            details.open ? this.handleOpen(details) : this.handleClose(details);
            details.addEventListener('toggle', this.onToggle.bind(this));
          });
      }

      onToggle(event) {
        const activeDetails = event.target;
        
        if (activeDetails.open) {
          this.handleOpen(activeDetails);
          this.scrollToAccordion(activeDetails);
        } else {
          this.handleClose(activeDetails);
        }
      }

      scrollToAccordion(details) {
        // Wait for the accordion to fully open before scrolling
        setTimeout(() => {
          const parent = details.closest('.accordion-item');
          
          if (parent) {
            const headerOffset = 150; // Larger offset to clear sticky header + breathing room
            const rect = parent.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const targetPosition = rect.top + scrollTop - headerOffset;
            
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
          } else {
            details.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 350); // Wait for accordion animation to complete
      }

      handleOpen(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.add(this.colorScheme);
      }

      handleClose(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.remove(this.colorScheme);
      }
    }
  );
}
